export const START_EMISSION = "@EMISSION/START_EMISSION";
export const START_EMISSION_DONE = "@EMISSION/START_EMISSION_DONE";

export const SAVE_EMISSION = "@EMISSION/SAVE_EMISSION";
export const SAVE_EMISSION_DONE = "@EMISSION/SAVE_EMISSION_DONE";
